var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dataBoardBox',{attrs:{"title":"各开设班级人数分布总览"}},[_c('div',{ref:"classStudentData",staticStyle:{"height":"400px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }